import { IconButton } from "@mui/material";

export const CustomIconButton = ({ icon, onClick, sx, className, size = "medium", bgcolor, ...rest }) => {
    return (
        <IconButton className={className} onClick={onClick}  
         sx={{
            bgcolor: bgcolor,
            "&:hover": {
                bgcolor: bgcolor,
            },
            ...sx
        }} size={size} {...rest}>
            {icon}
        </IconButton>
    );
};